import { mapToBreakpoints } from './mapToBreakpoints.js';

/**
 * Get CSS declaration for a particular spacing, optionally for particular breakpoint(s)
 * @param {string|object} values Spacing value, optionally for a given breakpoint (e.g. 0.5 or {m: '0.5'})
 * @param {string} prop Which CSS property to use (e.g. margin-bottom)
 * @returns {string} CSS declaration for the desired color / breaking point
 */
const spaceProp = (steps, prop = 'margin-bottom') => ({
  theme
}) => {
  if (!steps && steps !== 0) return '';
  return mapToBreakpoints(steps, step => {
    return `
        ${prop}: ${theme.spacing[step]};
      `;
  });
};

export { spaceProp };
//# sourceMappingURL=spaceProp.js.map
